// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IdToolboxAM } from 'src/app/shared/models/toolbox.model';
import { env } from './.env';

const env_api = env.apiUrl || 'http://localhost:8000';
const env_img = env.imgUrl || 'http://localhost:8000';

export const environment = {
   production: false,
   apiUrl: env_api,
   imgUrl: env_img,
   IdToolbox: IdToolboxAM
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
